module.exports = __webpack_public_path__ + "static/fonts/iconfont.b50dccc.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/fonts/iconfont.eot?v=1.0.0
// module id = 1LVO
// module chunks = 34